import { CustomSvg, SvgIconDefaultProps } from '@libs/components';

const CirclePendingIcon: React.FC<SvgIconDefaultProps> = ({
  className,
  testId,
}) => {
  return (
    <CustomSvg
      className={className}
      data-cy={testId}
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
    >
      <path
        d="M12.5 2.08337C6.75626 2.08337 2.08334 6.75629 2.08334 12.5C2.08334 18.2438 6.75626 22.9167 12.5 22.9167C18.2438 22.9167 22.9167 18.2438 22.9167 12.5C22.9167 6.75629 18.2438 2.08337 12.5 2.08337ZM14.8755 15.9172C14.7229 16.0698 14.5229 16.1459 14.3229 16.1459C14.1229 16.1459 13.9229 16.0698 13.7703 15.9172L11.1662 13.3131C11.0198 13.1662 10.9375 12.9677 10.9375 12.7605V7.03129C10.9375 6.59952 11.287 6.25004 11.7188 6.25004C12.1505 6.25004 12.5 6.59952 12.5 7.03129V12.437L14.8755 14.8125C15.1802 15.1172 15.1802 15.612 14.8755 15.9172Z"
        fill="white"
      />
    </CustomSvg>
  );
};
export default CirclePendingIcon;
